import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteNewsFn, getNewsFn } from 'Services/News';

const News = () => {
    const navigate = useNavigate();

    const { data: getNewsResponse, refetch } = useQuery({
        queryKey: "get-news",
        queryFn: getNewsFn
    });

    const { mutate: deleteBlog } = useMutation(deleteNewsFn, {
        onSuccess: (response) => {
            toast.success("Deleted Successfully");
            refetch();
        }
    });

    const deleteHandle = (id) => {
        const formData = new FormData();
        formData.append("news_id", id);
        deleteBlog(formData);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    News
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/news/add`)}
                >
                    Add
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {getNewsResponse?.data?.data?.map((item) => (
                    <Card key={item.id} className="bg-white shadow-lg rounded-lg">
                        <CardMedia
                            component="img"
                            style={{ height: '200px', objectFit: 'cover' }}
                            image={imageURL(item.image)}
                            alt={item.title}
                        />
                        <CardContent>
                            <Typography variant="h6" component="div" className="mb-2 line-clamp-2">
                                {item.title}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                className="line-clamp-3"
                                dangerouslySetInnerHTML={{ __html: item.content }}
                            />
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/news/update/${item?.id}`)}
                            >
                                <EditIcon />
                                Update
                            </Button>
                            <Button
                                size="small"
                                color="error"
                                onClick={() => deleteHandle(item.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default News;
